Questa prova contiene _4 problemi_ di **programmazione** tramite blocchi da risolvere in _180 minuti_.
I problemi sono ordinati per difficoltà crescente.
**Attento che la difficoltà è soggettiva!** Se stai passando tanto tempo cercando di risolvere un problema, prova a passare ad altri problemi e altre categorie!

## Punteggio

I problemi richiedono di scrivere un **singolo** programma a blocchi, che viene valutato **contemporaneamente** su 10 diversi livelli.
Quindi attenzione che non puoi scrivere programmi diversi per i diversi livelli, ma uno solo!
Per ciascun problema e per ciascun livello, Il punteggio che puoi ottenere è:

- 5 punti se il programma produce la risposta _corretta_;
- 0 punti se il programma produce una risposta _sbagliata_.

Quindi ogni domanda a blocchi può valere fino a 50 punti in totale.
